/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { locationMemberSchema } from './locationMemberSchema';

export const pageResponseLocationMemberSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(locationMemberSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
